// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l0-2";
export var container = "_l0-4";
export var dismissButton = "_l0-3";
export var hasPaddingBottom = "_l0-6";
export var last = "_l0-e";
export var scrollbarThumb = "_l0-c";
export var scrollbarTrack = "_l0-b";
export var selected = "_l0-9";
export var spin = "_l0-1";
export var spinning = "_l0-0";
export var suggestionItem = "_l0-d";
export var suggestionsPanel = "_l0-5";
export var tonePill = "_l0-8";
export var tonesContainer = "_l0-7";
export var unselected = "_l0-a";